<template>
  <div :class="[`content`, `content__home`]">
    <video-background :sources="videoSources" />
    <div class="cta">
      <span class="logo" />

      <div class="cta__buttons">
        <router-link
          v-for="(path, index) in chapterPaths"
          :key="index"
          :to="path.url"
          class="cta__button"
        >
          {{ path.label }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import navigation from '@/models/navigation'
import VideoBackground from '@/components/VideoBackground'

export default {
  name: 'view-home',

  // Data
  data () {
    return {
      transitioning: false,
      videoSources: [
        require('@/assets/video/background.mov'),
        require('@/assets/video/background.mp4')
      ],
      chapterPaths: navigation.map((ch) => ({
        url: `page/${ch.identifier}/`,
        label: `${ch.title} ${ch.description}`
      }))
    }
  },

  components: {
    VideoBackground
  },

  // Methods
  methods: {
    ...mapActions(`header`, [`toggleHeader`]),
    ...mapActions(`navigation`, [`toggleNavigation`]),
    ...mapActions(`sidebar`, [`toggleSidebar`]),

    startPresentation () {
      this.$router.push({
        name: `page`
      })
    }
  },

  // Watchers

  // Lifecycles
  mounted () {
    this.toggleHeader(false)
    this.toggleNavigation(false)
    this.toggleSidebar(false)
  }
}
</script>
